
import axios from 'axios'
import Router from '@/router'
import store from '../../store/index.js'

// 创建一个 axios 实例
const service = axios.create({
  baseURL: process.env.VUE_APP_API,
  timeout: 50000 // 请求超时时间
})
// 带cookies
service.defaults.withCredentials = true
// 特殊字符替换
function htmlDecodeByRegExp (str) {  
  var s = ''
  if (str.length == 0) return ''
  s = str.replace(/&amp;/g, '&')
  s = s.replace(/&lt;/g, '<')
  s = s.replace(/&gt;/g, '>')
  s = s.replace(/&nbsp;/g, ' ')
  s = s.replace(/&#39;/g, "\'")
  s = s.replace(/&quot;/g, '\\\"')
  s = s.replace(/(\\\\\*)/g, '\*')
  s = s.replace(/(\\\\\%)/g, '\%')
  s = s.replace(/(\\\\\_)/g, '\_')
  return s
}
// 请求拦截器
service.interceptors.request.use(
  config => {
    // 在请求发送之前做一些处理
    // // 让每个请求携带token-- ['X-Token']为自定义key 请根据实际情况自行修改
	
	let token = store.state.token;
	// console.log(token,'axios token')
	if(token){
		config.headers['Token'] = store.state.token;
	}else{
		config.headers['Token'] = '';
	}
	
    // if (config.method == 'post') {
    //   if (util.cookies.get('token')) {
    //     const token = util.cookies.get('token')
    //     if (config.data) {
    //       config.data.token = token
    //     } else {
    //       config.data = { token: token }
    //     }
    //   }
    // }
    return config
  },
  error => {
    // 发送失败
    Promise.reject(error)
  }
)

// 响应拦截器
service.interceptors.response.use(
  response => {
    if (response.config.responseType === 'blob') {
      return Promise.resolve(response)
    } else {
      if (response.data.code === 400) {
        Router.replace('/login')
        return  response
      } else {
        const dataAxios = response
        // return dataAxios
        // // console.log(dataAxios)
        return JSON.parse(htmlDecodeByRegExp(JSON.stringify(dataAxios)))
      }
    }
  },
  error => {
    return Promise.reject(error)
  }
)

export default service



// WEBPACK FOOTER //
// ./src/assets/js/axios.js